import { render, staticRenderFns } from "./InputRange.vue?vue&type=template&id=489c29b1&scoped=true"
import script from "./InputRange.vue?vue&type=script&lang=js"
export * from "./InputRange.vue?vue&type=script&lang=js"
import style0 from "./InputRange.vue?vue&type=style&index=0&id=489c29b1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489c29b1",
  null
  
)

export default component.exports